import { ChevronLeft } from "lucide-react";
import { Link } from "react-router-dom";
import { cn } from "@/lib/utils";

export function SettingsBackLink({
  to,
  label,
  className,
}: {
  to: string;
  label: string;
  className?: string;
}) {
  return (
    <Link
      to={to}
      className={cn(
        "-ml-1 mb-3 inline-flex items-center gap-1 text-sm text-muted-foreground hover:text-foreground transition-colors",
        className,
      )}
    >
      <ChevronLeft className="h-4 w-4 shrink-0" />
      <span className="truncate">{label}</span>
    </Link>
  );
}

export default SettingsBackLink;
